'use strict';
module.exports = function (app) {
    app.controller('dashBoardController', ['$scope', '$rootScope', 'socket', 'syncDisPlayProductFactory', 'BiddingRateIncreaseFactory', 'FrontEndService', 'lodash', 'deviceDetector', '$timeout', '$translate', '$http', 'Analytics', '$cookies', 'ngDialog', function ($scope, $rootScope,socket, syncDisPlayProductFactory, BiddingRateIncreaseFactory, FrontEndService,_, deviceDetector, $timeout, $translate, $http, Analytics, $cookies, ngDialog) {
        $scope.user;
        $scope.magUrl = "";
        $scope.isFinishedCreateBid = false;
        $scope.isAvailableBiggerBid = false;
        $scope.isTermApproved =  {status: false};
        $scope.indexDisplayProduct = 0;
        $scope.products = [];
        $scope.displayProduct;
        //value to track to enable createBid button
        $scope.isEnable = true;
        $scope.headerMenuHeight = 220;
        //detect mobile OS, do not show video on mobile OS due to latency
        $scope.isMobile = deviceDetector.isMobile();
        //is in delaying Process
        $scope.isDelaying = false;
        //is user has participated in the auction
        $scope.isParticipated = false;
        //setting for apply different style for different views
        $rootScope.bodylayout = 'dash-board';
        var preDisplayProduct;

        $scope.init = {
            inputPrice: 0
        };

        if($cookies.get('termApproved') === "1") {
             $scope.isTermApproved.status = true;
        }

        $scope.termApprove = function (isTermApproved) {
            var value = isTermApproved.status ? 1 : 0;
            $cookies.put('termApproved', value);
        };

        $scope.openTermModal = function () {
            ngDialog.openConfirm({
                template: require('../template/' + $rootScope.lang + '/modal_term.html'),
                plain: true,
                closeByNavigation: true
            });
        };

        $scope.openQuestionsAndAnswerModal = function () {
            ngDialog.openConfirm({
                template: require('../template/' + $rootScope.lang + '/modal_question-and-answers.html'),
                plain: true,
                closeByNavigation: true
            });
        };

       FrontEndService.url().then(function onSuccess(response) {
           if (response.status === 200) {
               $scope.img_url = response.data.product_images_url;

               //if it is not testing server call google analytics function
               if (response.data.magento_url.match(/dev./g) === null) {
                   Analytics.pageView();
               }
           }
       });

        function successCreateBid (response) {
            $scope.isFinishedCreateBid = true;
            $scope.isParticipated = true;
        }

        function successGetLocale(response){
            if (response === 'english') {
                $rootScope.lang = 'en';
                $translate.use('en');
            }else if( response === 'svenska') {
                $rootScope.lang = 'sv';
                $translate.use('sv');
            } else {
                $rootScope.lang = 'fi';
                $translate.use('fi');
            }
        }

        function successGetCustomer(response) {
            if(response) {
                $scope.user = response;
            }
        }

        function successGetProducts(response) {
            var products = response;
            var displayProduct = syncDisPlayProductFactory.getStartedProduct(response);

            //keep track of previous display product
            if (preDisplayProduct === undefined) {
                preDisplayProduct = displayProduct;
                $scope.isDelaying = true;
                $timeout(updateDisplayProducts, 800);
            } else if (preDisplayProduct.products_id !== displayProduct.products_id) {
                //update previous product, reset isParticipated Stated
                preDisplayProduct = displayProduct;
                $scope.isParticipated = false;
                $scope.isDelaying = true;
                $timeout(updateDisplayProducts, 800);
            } else {
                // if the product is the same do not deplay to update
                $timeout(updateDisplayProducts, 0);
            }

            function updateDisplayProducts() {
                $scope.isDelaying = false;
                $scope.displayProduct = displayProduct;
                $scope.lastBid = $scope.displayProduct.$lastBid;
                $scope.displayProduct.img = $scope.displayProduct.image[0];

                $timeout(function () {
                    //using view_port_helper.directive.js to manipulate the products array.
                    $scope.$broadcast('products:loaded', products);
                },0);

                //cases for init value with different bidding scenarios
                if ($scope.displayProduct.$lastBid) {
                    $scope.isEnable = false;

                    //create 400ms deplay to avoid user unwanted bid
                    $timeout(function(){
                        $scope.init.inputPrice = BiddingRateIncreaseFactory.autoIncreaseBidFn($scope.displayProduct.$lastBid.price);
                        $scope.isEnable = true;
                    }, 400);
                }
                else if ($scope.displayProduct.$lastBid === undefined && $scope.displayProduct.controlled_price > 0 && ($scope.displayProduct.online_pre_price < $scope.displayProduct.controlled_price || $scope.displayProduct.online_pre_price === 0 ) ) {
                    $scope.init.inputPrice = $scope.displayProduct.controlled_price - BiddingRateIncreaseFactory.amountCountReversed($scope.displayProduct.controlled_price);
                }
                else if ($scope.displayProduct.$lastBid === undefined && $scope.displayProduct.controlled_price > 0) {
                    $scope.init.inputPrice = $scope.displayProduct.controlled_price;
                }
                else if ($scope.displayProduct.$lastBid === undefined && $scope.displayProduct.controlled_price === 0) {
                    $scope.init.inputPrice = 10;
                }

                $scope.createBid = function (inputPrice, product) {
                    //reset back to default value
                    $scope.isFinishedCreateBid = false;
                    $scope.isAvailableBiggerBid = false;
                    inputPrice = parseInt(inputPrice, 10);

                    var customer_id = $scope.user ? $scope.user.customer_id : '1234';
                    var customer_name = $scope.user ? $scope.user.customer_name : "Matti M.";

                    //auto create new increase bid for the pre bidding scenario
                    // prevent user make more bid when his bid is leading
                    if ( typeof $scope.displayProduct.$lastBid !== "undefined" &&  $scope.displayProduct.$lastBid.customer_id !== customer_id && inputPrice > 0 && !product.online_bidding_locked && $scope.isEnable ) {
                        socket.emit('create:bid', {
                            "products_id": product.products_id,
                            "price": inputPrice
                        });
                    }
                };

                $scope.updateImg = function (img) {
                    $scope.displayProduct.img = img;
                };
            }
        }

         function updateTopBids(response){
             if(typeof response !== "undefined") {
                 $scope.topBids = response;
             }
         }


        socket.on('update:topBids', updateTopBids);

        socket.on('finished:create:bid', successCreateBid);
        socket.on('rejected:create:bid', function(err) {
            if (err === 'TypeError: There was bigger bid than yours!') {
                $scope.isAvailableBiggerBid = true;
            }
        });
        socket.on('store', successGetLocale);
        socket.on('update:customer', successGetCustomer);
        socket.on('update:products', successGetProducts);
        socket.emit('get:model');
        socket.on('backend:error', function (error) {
            console.log(error);
        });
    }]);
};



/*****************
 ** WEBPACK FOOTER
 ** ./dash_board/js/dashBoard.controller.js
 ** module id = 32
 ** module chunks = 0
 **/